import { render, staticRenderFns } from "./AccisureComissionReportForm.vue?vue&type=template&id=60e7aa72&scoped=true"
import script from "./AccisureComissionReportForm.vue?vue&type=script&lang=js"
export * from "./AccisureComissionReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7aa72",
  null
  
)

export default component.exports